import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login_sheet" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "login_title" }
const _hoisted_4 = { class: "login_desc" }
const _hoisted_5 = { class: "leave_dialog" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "leave_title" }
const _hoisted_8 = { class: "leave_desc" }
const _hoisted_9 = { class: "leave_actions" }

import { computed } from 'vue';
import LoginIcon from '@/assets/img/meeting-room/login-user.png';
import NoticeIcon from '@/assets/img/meeting-room/notice.png';


export default /*@__PURE__*/_defineComponent({
  __name: 'MeetingRoomModals',
  props: {
    showLogin: { type: Boolean },
    showLeave: { type: Boolean }
  },
  emits: ["update:showLogin", "update:showLeave", "login", "leave"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const loginVisible = computed({
  get: () => props.showLogin,
  set: (value) => emit('update:showLogin', value),
});

const leaveVisible = computed({
  get: () => props.showLeave,
  set: (value) => emit('update:showLeave', value),
});

return (_ctx: any,_cache: any) => {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_modal, {
      visible: loginVisible.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((loginVisible).value = $event)),
      footer: null,
      closable: false,
      "mask-closable": true,
      "destroy-on-close": false,
      "wrap-class-name": "meeting_login_modal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "sheet_close",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (loginVisible.value = false))
          }, _cache[7] || (_cache[7] = [
            _createElementVNode("span", null, null, -1),
            _createElementVNode("span", null, null, -1)
          ])),
          _createElementVNode("img", {
            class: "login_icon",
            src: _unref(LoginIcon),
            alt: ""
          }, null, 8, _hoisted_2),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('参与互动需要登录')), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('请登录 Envo 账号后，即可参与会议聊天、表情互动和更多功能')), 1),
          _createElementVNode("button", {
            class: "login_primary",
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('login')))
          }, _toDisplayString(_ctx.$t('前往 APP 登录')), 1),
          _createElementVNode("button", {
            class: "login_secondary",
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (loginVisible.value = false))
          }, _toDisplayString(_ctx.$t('我知道了')), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: leaveVisible.value,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((leaveVisible).value = $event)),
      footer: null,
      closable: false,
      "mask-closable": false,
      "destroy-on-close": false,
      centered: "",
      "wrap-class-name": "meeting_leave_modal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: _unref(NoticeIcon),
            alt: ""
          }, null, 8, _hoisted_6),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('提示')), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('确认离开当前会议?')), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (leaveVisible.value = false))
            }, _toDisplayString(_ctx.$t('继续观看')), 1),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('leave')))
            }, _toDisplayString(_ctx.$t('离开')), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})